import React, { useContext } from 'react';
import Styled from 'styled-components';
import messageStripe from '@components/MessageStripe';
import { useRouter } from 'next/router';
import LanguageContext from '@lib/contexts/languageContext';
import useFlags from '@lib/hooks/useFlags';
import { isEnabledOnPage } from '@lib/utils';

const MessageStripe = Styled(messageStripe)`
  /* using the line below to increase specificity */
  &&& {
    display: flex;
    padding: 5px 0;
    z-index: 10;
  }
`;

const ENABLED_PATHS = [
  { path: '/[lang]/videos/genres/[genre]', exact: true },
  { path: '/[lang]/programs', exact: true },
  { path: '/[lang]/challenge', exact: true },
];

const SpringBoostBanner = () => {
  const router = useRouter();
  const [flags] = useFlags();
  const lang = useContext(LanguageContext);

  const allowed_on_page = isEnabledOnPage(ENABLED_PATHS, router.pathname);

  if (
    ['se', 'no'].includes(lang) &&
    allowed_on_page &&
    !flags.yearly_campaign_banners &&
    flags.yearly_campaign
  ) {
    return (
      <MessageStripe bg="#D9E8E7" color="#242424">
        <a href="/se/c/yogobe/b/spring-boost">
          Gå med i Spring Boost och möt våren med ny energi! 8 veckor träning,
          kost och återhämtning med start 1 mars. Anmäl dig här! 
        </a>
      </MessageStripe>
    );
  }

  return null;
};

export default SpringBoostBanner;
